import React from 'react'
import { LoadingOutlined } from '@ant-design/icons'
import { Layout, Spin } from 'antd'
import { connect } from 'react-redux'
import { store as reduxStore } from 'index'
import Confetti from 'react-confetti'
import { withRouter } from 'react-router-dom'
import Menu from 'components/layout/Menu'

// modals
import ModalOnboarding from 'components/modals/Onboarding'
import ModalNewApp from 'components/modals/NewApp'
import ModalCongratulations from 'components/modals/Congratulations'
import ModalAppCreationFailed from 'components/modals/AppCreationFailed'
import ModalAppCreationFailedException from 'components/modals/AppCreationFailedException'

import ModalScheduleDeleted from 'components/modals/ScheduledToDelete'
import ModalSwitchingBack from 'components/modals/SwitchingBack'
import ModalImportUser from 'components/modals/ImportUsers'
import ModalAppHipaaUSCreated from 'components/modals/AppHipaaUSCreated'
import ModalFilterApp from 'components/modals/AppFilter'
import ModalSubscriptionOngoing from 'components/modals/SubscriptionOngoing'
import ModalSubscriptionSuccess from 'components/modals/SubscriptionSuccess'
import ModalSubscriptionSuccessDowngrade from 'components/modals/SubscriptionSuccessDowngrade'
import ModalSubscriptionCancelledEndOfTerm from 'components/modals/SubscriptionCancelledEndOfTerm'
import ModalSubscriptionDowngradeEndOfTerm from 'components/modals/SubscriptionDowngradeEndOfTerm'
import ModalSubscriptionDowngradeEOTCancelled from 'components/modals/SubscriptionDowngradeEOTCancelled'
import NotificationComponent from 'components/design/Form/Notifications'
import ModalIntentRequest from 'components/modals/IntentRequest'
import ModalUpgradeToUnlockFeature from 'components/modals/UpgradeToUnlockFeature'
import ModalUpgradeToUnlockAIFeature from 'components/modals/UpgradetoUnlockAIFeature'
import ModalUpgradeToUnlockWebhookFeature from 'components/modals/UpgradeToUnlockWebhookFeature'
import ModalUpgradeToUnlockModerationFeature from 'components/modals/UpgradeToUnlockModerationFeature'
import ModalUpgradeToUnlockModerationRulesFeature from 'components/modals/UpgradeToUnlockModerationRulesFeature'
import ModalUpgradeToUnlockEmailNotificationFeature from 'components/modals/UpgradeToUnlockEmailNotificationFeature'
import ModalUpgradeToUnlockSMSNotificationFeature from 'components/modals/UpgradeToUnlockSMSNotificationFeature'
import ModalUpgradeToUnlockPushNotificationFeature from 'components/modals/UpgradeToUnlockPushNotificationFeature'
import ModalUpgradeToUnlockNotificationsFeature from 'components/modals/UpgradeToUnlockNotificationsFeature'
import ModalUpgradeToUnlockNotificationsPreferences from 'components/modals/UpgradeToUnlockNotificationsPreferences'
import ModalUpgradeToUnlockNotificationTemplates from 'components/modals/UpgradeToUnlockNotificationTemplates'
import ModalUpgradeToUnlockModerationAdvancedRulesFeature from 'components/modals/UpgradeToUnlockModerationAdvancedRulesFeature'
import ModalUpgradeToUnlockModerationKeywordList from 'components/modals/UpgradeToUnlockModerationKeywordList'
import ModalAIFeatures from 'components/modals/AiFeatures'
import ModalAISettings from 'components/modals/AiSettings'
import ModalSlackConnect from 'components/modals/SlackConnect'
import _ from 'lodash'
import NotificationsLogModal from 'components/modals/NotificationsLogEnabled'
import ConversationSearchEnabled from 'components/modals/ConversationSearchEnabled'
import constants from '../../constants'
import style from './style.module.scss'

import { isAppOwner, checkIfPlanExpired } from '../../helpers'
import PlanUpgradeBanner from '../../components/design/Feedback/PlanUpgradeBanner'
import PlanSubscribeBanner from '../../components/design/Feedback/PlanSubscribeBanner'

const mapStateToProps = ({ apps, user, settings }) => ({ apps, user, settings })
@withRouter
@connect(mapStateToProps)
class MainLayout extends React.PureComponent {
  static triggerNotification = (text = '', type = 'success') => {
    const { dispatch } = reduxStore || {}

    dispatch({
      type: 'apps/INITIATE_NOTIFICATION',
      payload: { type, message: text },
    })
  }

  static triggerManualIntent = (intent = '') => {
    const { dispatch } = reduxStore || {}

    dispatch({
      type: 'apps/GTM_TRIGGERED_MANUAL_INTENT',
      payload: { intent },
    })
  }

  componentDidMount() {
    // Attach the function to the global `window` object
    if (typeof window !== 'undefined') {
      window.triggerNotification = MainLayout.triggerNotification
      window.triggerManualIntent = MainLayout.triggerManualIntent
    }
  }

  componentWillUnmount() {
    // Clean up to avoid leaving unused references
    if (typeof window !== 'undefined') {
      delete window.triggerNotification
      delete window.triggerManualIntent
    }
  }

  handleTrialExpiredAppBannerClick = () => {
    const { location, apps } = this.props
    if (!_.includes(location.pathname, 'plans-billing/change') && isAppOwner(apps.active)) {
      const { history } = this.props
      if (apps.active.region === 'legacy') history.push(`/app/${apps.active.id}/plans-billing`)
      else history.push(`/app/${apps.active.id}/plans-billing/change`)
    }
  }

  render() {
    const { children, apps, settings } = this.props
    const { appUsageAndOverages } = apps
    const confettiColors = ['#6852D6']

    const isUsageAvailable =
      appUsageAndOverages.currentUsageUsers ||
      appUsageAndOverages.voice_minutes ||
      appUsageAndOverages.ccu ||
      appUsageAndOverages.video_minutes

    const {
      location: { pathname },
    } = this.props

    const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />
    let pageLoader = false
    let loaderText = ''
    let displayBanner = false
    let displaySubscribeBanner = false
    const loaderPaths = [
      'plans-billing',
      'notifications-logs',
      'ai-agent/get-started',
      'messaging-get-started',
      'calling-get-started',
    ]
    if (_.indexOf(pathname, 'plans-billing') >= 0 && apps.loading) {
      pageLoader = true
    }
    if (loaderPaths.some(path => pathname.includes(path)) && apps.loading) {
      pageLoader = true
    }

    if (pathname.includes('/app/') && checkIfPlanExpired(apps.active.plan)) {
      displaySubscribeBanner = true
    } else if (
      pathname.includes('/app/') &&
      _.includes(constants.trialPlansIDList, apps.active.plan) &&
      isUsageAvailable
    ) {
      displayBanner = true
    }

    if (pathname === '/apps' || pathname.includes('builder') || pathname.includes('ai-agents/')) {
      pageLoader = false
      displayBanner = false
      displaySubscribeBanner = false
    }

    const isBuilderPath = _.includes(pathname, 'builder')

    if (pathname === '/apps' && apps.firstAppCreationInProgress) {
      pageLoader = true
      loaderText = 'Hold tight, your app is almost ready to launch! (Finalizing setup)...'
    }

    if (pathname === '/create-application') {
      displayBanner = false
      pageLoader = false
    }

    const mainLayoutClasses = style.bodyRight
    let mainContainerClasses = `${style.com__main} ${style.com__main_custom}`
    let layoutContentClasses = style.contentWithLeftnav
    if (
      pathname === '/settings' ||
      pathname === '/apps' ||
      pathname === '/create-application' ||
      pathname === '/choose-role'
    ) {
      layoutContentClasses = ''
    }

    if (isBuilderPath) {
      layoutContentClasses = ''
      mainContainerClasses = `${style.com__main}`
    }

    const innerLoaderStyles = { height: '96vh' }
    let contentBgColor = '#ffffff'
    if (
      pathname === '/apps' ||
      pathname === '/create-application' ||
      pathname === '/settings' ||
      isBuilderPath
    ) {
      contentBgColor = '#efeff0'
    }

    return (
      <React.Fragment>
        <Spin tip={loaderText} spinning={pageLoader} size="large" indicator={antIcon}>
          {settings.showModalConfetti && (
            <Confetti
              wind={0}
              style={{ zIndex: 100001 }}
              width={window.innerWidth}
              height={window.innerHeight}
              tweenDuration={6000}
              recycle={false}
              initialVelocityY={5}
              numberOfPieces={300}
              colors={confettiColors}
            />
          )}
          <div className={mainContainerClasses}>
            {displayBanner && <PlanUpgradeBanner />}
            {displaySubscribeBanner && <PlanSubscribeBanner />}
            <Layout className={mainLayoutClasses}>
              <Layout>
                {pathname !== '/apps' &&
                  pathname !== '/create-application' &&
                  pathname !== '/settings' &&
                  !isBuilderPath && (
                    <Menu displayBanner={displayBanner || displaySubscribeBanner} />
                  )}
                <Layout style={{ position: 'relative', background: contentBgColor }}>
                  <Spin
                    spinning={pathname.includes('overview') && apps.loading}
                    size="large"
                    indicator={antIcon}
                    // fullscreen
                    style={innerLoaderStyles}
                  >
                    <Layout.Content
                      className={layoutContentClasses}
                      style={displayBanner || displaySubscribeBanner ? { marginTop: '40px' } : {}}
                    >
                      <div
                        className="com__content"
                        style={pathname === '/apps' ? { background: '#FAFAFA' } : {}}
                      >
                        {children}
                      </div>
                    </Layout.Content>
                  </Spin>
                </Layout>
              </Layout>
            </Layout>
            <ModalOnboarding />
            <ModalNewApp />
            <ModalCongratulations />
            <ModalAppCreationFailed />
            <ConversationSearchEnabled />
            <ModalAIFeatures />
            <ModalAISettings />
            <ModalSlackConnect />
            <ModalAppCreationFailedException />
            <ModalFilterApp />
            <ModalScheduleDeleted />
            <ModalAppHipaaUSCreated />
            <ModalSubscriptionOngoing />
            <ModalSubscriptionSuccess />
            <ModalSubscriptionSuccessDowngrade />
            <ModalSubscriptionCancelledEndOfTerm />
            <ModalSubscriptionDowngradeEndOfTerm />
            <ModalSubscriptionDowngradeEOTCancelled />
            <ModalIntentRequest />
            <NotificationComponent />
            <ModalSwitchingBack />
            <ModalImportUser />
            <ModalUpgradeToUnlockFeature />
            <ModalUpgradeToUnlockAIFeature />
            <ModalUpgradeToUnlockWebhookFeature />
            <ModalUpgradeToUnlockModerationFeature />
            <ModalUpgradeToUnlockModerationRulesFeature />
            <ModalUpgradeToUnlockEmailNotificationFeature />
            <ModalUpgradeToUnlockSMSNotificationFeature />
            <ModalUpgradeToUnlockPushNotificationFeature />
            <ModalUpgradeToUnlockNotificationsFeature />
            <ModalUpgradeToUnlockNotificationsPreferences />
            <ModalUpgradeToUnlockNotificationTemplates />
            <ModalUpgradeToUnlockModerationAdvancedRulesFeature />
            <ModalUpgradeToUnlockModerationKeywordList />
            <NotificationsLogModal />
          </div>
        </Spin>
      </React.Fragment>
    )
  }
}

export default MainLayout
